import React, { useEffect, useState, useLayoutEffect  } from 'react';
import BottomNav from './BottomNav';
import UserHeader from './UserHeader';
import ModuleCard from './ModuleCard';
import SidebarYou from './SidebarYou';
import axios from 'axios';
import {
  isMobile,
  isTablet,
  isSmartTV,
  isBrowser,
} from 'react-device-detect';
import './dashboardyou.css';
import TopBarYou from './TopBarYou';
import CarouselSection from './CarouselSection';

const DashboardYou = () => {
  const [modulosPersonalizados, setModulosPersonalizados] = useState([]);
  const [modulosPorGrupo, setModulosPorGrupo] = useState([]);
  const [tema, setTema] = useState(localStorage.getItem("tema") || "dark");

  useLayoutEffect(() => {
  document.body.classList.add('dark-mode');
}, []);

  useEffect(() => {
    const tema = localStorage.getItem("tema");
    if (tema === "dark") {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, []);

  useEffect(() => {
    const base = "sidebar-mini layout-fixed layout-navbar-fixed";
    const modo = tema === "dark" ? "dark-mode" : "";
    document.body.className = `${base} ${modo}`;
    if (isMobile || isTablet) {
      const aside = document.querySelector('aside.main-sidebar');
      if (aside) aside.style.display = 'none';
    }
  }, [tema]);

  useEffect(() => {
    const id_user = JSON.parse(atob(sessionStorage.getItem("KEY_APP_BGG").split('.')[1]))[0].id;
    const formData = new FormData();
    formData.set('id_user', id_user);

    axios.post("https://api.youevolution.com.br/getDashboardModules.php", formData)
      .then(res => {
        console.log(res.data);
        setModulosPersonalizados(res.data.modulos_personalizados || []);
        setModulosPorGrupo(res.data.modulos_por_grupo || []);
      })
      .catch(err => {
        console.error("🚨 Erro ao carregar módulos", err);
        setModulosPersonalizados([]);
        setModulosPorGrupo([]);
      });
  }, []);

  const toggleTema = () => {
    const novoTema = tema === "dark" ? "" : "dark";
    setTema(novoTema);
    localStorage.setItem("tema", novoTema);
  };

  // Agrupar modulos_por_grupo por nome do grupo
  const gruposUnicos = [...new Set(modulosPorGrupo.map(m => m.grupo))];
  const modulosPorGrupoNome = gruposUnicos.map(grupo => ({
    grupo,
    modulos: modulosPorGrupo.filter(m => m.grupo === grupo)
  }));

  return (
    <div className={`dashboard-you min-h-screen ${tema}`}>
      {!(isMobile || isTablet) && <TopBarYou />}
      {(isBrowser || isSmartTV) && <SidebarYou />}

      <div
        className={`dashboard-content mt-4 pb-5 ${isSmartTV ? 'text-lg' : ''}`}
        style={{
          paddingTop: !(isMobile || isTablet) ? '70px' : '0px',
          marginLeft: isBrowser || isSmartTV ? '65px' : '0',
          transition: 'margin-left 0.3s ease'
        }}
      >

        {/* Módulos personalizados primeiro */}
        {modulosPersonalizados.length > 0 && (
          <CarouselSection
            titulo="🔑 Meu Universo"
            modulos={modulosPersonalizados}
            autoScroll={false}
          />
        )}

        {/* Módulos agrupados por grupo */}
        {modulosPorGrupoNome.map((grupoItem, idx) => (
          <CarouselSection
            key={idx}
            titulo={`📁 ${grupoItem.grupo}`}
            modulos={grupoItem.modulos}
            autoScroll={false}
          />
        ))}
      </div>

      {(isMobile || isTablet) && <BottomNav />}
    </div>
  );
};

export default DashboardYou;
